export interface ApiConfig {
    /**
     * LocalStorage中のキー
     * 例：`_token`
     */
    store_key: string;
    /**
     * トークンの有効期限切れの場合、指定ページに遷移する
     */
    token_invalid_redirect?: boolean;
    /**
     * トークンの有効期限切れのオフセット(秒単位)
     * トークンの有効期限切れ日時の計算方法：
     * トークン取得日時（クライアント日時）＋ 有効期限が切れるまでの秒数(expiresIn) - オフセット(token_exp_offset)
     */
    token_exp_offset?: number;
    /**
     * HTTPヘッダー中にトークンを送信するときのキー
     */
    token_send_key: string;
    /**
     * アクセス権限がないときの遷移先
     */
    login_url: string;
    /**
     * トークンの情報をチェックする必要がないURL
     * 例：`[/\/login/, /assets\//, /agreement\//]`
     */
    ignores?: RegExp[];
    /**
     * リクエストパラメータ中に該当キーがあれば、トークンの情報をチェックしない
     * 例：`_allow_anonymous`
     */
    allow_anonymous_key: string;
    /**
     * Mock情報を出力する、デフォルト：`true`
     */
    log?: boolean;
    /**
     * 他のインターセプターを実行し続ける、デフォルト：`true`
     */
    executeOtherInterceptors?: boolean;

}

export const API_CONFIG: ApiConfig = {
    store_key : `_token`,
    token_invalid_redirect : true,
    token_exp_offset : 60,
    token_send_key : `co-token`,
    login_url : '/auth/login',
    ignores : [/\/login$/, /assets\//, /api\//],
    allow_anonymous_key : `_allow_anonymous`,
    log :false,
    executeOtherInterceptors : true,
};